import { openOverlay } from "overlay"
import type { UserPriv } from "luxedo-data"
import { userRepo } from "../../stores/CurrentUser.svelte"
import ContentSuggestions from "./ContentSuggestions.svelte"
import ProContentSolutions from "./ProContentSolutions.svelte"

// Typed annotation (not a cast) so a rename in the UserPriv union fails the build here
const PRO_PRIV: UserPriv = "pro"

/** PRO accounts work with our in-house content team directly, so they get the
 * custom-show order form instead of the self-serve resource list. */
export function openProContentSolutions() {
	openOverlay(ProContentSolutions, { classOverlay: "no-min" })
}

export function showContentSuggestions() {
	if (userRepo.user?.hasPriv(PRO_PRIV)) return openProContentSolutions()

	openOverlay(ContentSuggestions, {
		classHeading: "no-underline",
	})
}
